/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { service } from '@ember/service';

export default class ListsController extends Controller {
  @service
  router;

  @service
  roles;

  @computed('router.currentRouteName')
  get listBuilderTab() {
    if (
      this.get('router.currentRouteName').indexOf('admin.lists.exports') === 0
    ) {
      return 'exports';
    } else {
      return 'premade';
    }
  }
}
